import Vue from 'vue';

Vue.component('modal', require('./Modal/Modal').default);
Vue.component('app-confirm-modal', require('./Modal/ConfirmModal').default);
Vue.component('app-delete-modal', require('./Modal/DeleteModal').default);
Vue.component('app-detail-modal', require('./Modal/DetailModal').default);
Vue.component('app-migration-modal', require('./Modal/MigrationModal').default);

Vue.component('list-available', require('./ListAvailable/Index').default);
